export default "__VITE_ASSET__eO8atc3l__"